import { alpha, ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC, ReactNode } from "react";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	icon: ReactNode;
	iconBg: string;
	label: string;
	onClick: () => void;
};

export const EmptyStateButton: FC<Props> = ({
	icon,
	iconBg,
	label,
	onClick,
}) => {
	const { palette, iconSize, radii } = useTheme();

	return (
		<ButtonBase
			onClick={onClick}
			sx={{ width: "100%", borderRadius: radii.lg }}
		>
			<Stack
				direction="row"
				alignItems="center"
				gap={1.5}
				width="100%"
				bgcolor={alpha(palette.darkmodeText.white, 0.15)}
				borderRadius={radii.lg}
				px={2}
				py={1.5}
				sx={{ backdropFilter: "blur(4px)" }}
			>
				<IconBox bg={iconBg}>{icon}</IconBox>
				<Typography variant="bodyMedium" color={palette.darkmodeText.white}>
					{label}
				</Typography>
				<ChevronRight
					size={iconSize.sm}
					color={alpha(palette.darkmodeText.white, 0.5)}
					style={{ marginLeft: "auto" }}
				/>
			</Stack>
		</ButtonBase>
	);
};
